<div class="modal-header container-fluid ab-modal__header" tabindex="0">
  <div class="ab-modal__close">
    <button
      class="btn btn--link-color btn--no-shadow"
      type="button"
      (click)="dismissModal()"
    >
      <i class="glyphicon glyphicon--45-deg glyphicon-ab-plus"></i>
      &nbsp;<span class="ab-modal__close__text">Close</span>
    </button>
  </div>
</div>
<div class="modal-body container-fluid ab-modal__body">
  <div class="row mb-3 text-center">
    <div class="col-md-12">
      <h4 class="ab-modal__subtitle">
        Check it out! You're seeing a new, empty project right now that you can
        explore, or, get started with your own project!
      </h4>
      <div class="text-center">
        <a class="btn btn--primary" (click)="showInstructions()">Get Started</a>
      </div>
    </div>
  </div>
</div>
